import { render, staticRenderFns } from "./AddProductExtension.vue?vue&type=template&id=42756208&scoped=true"
import script from "./AddProductExtension.vue?vue&type=script&lang=js"
export * from "./AddProductExtension.vue?vue&type=script&lang=js"
import style0 from "./AddProductExtension.vue?vue&type=style&index=0&id=42756208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42756208",
  null
  
)

export default component.exports